import { useState, useRef } from 'react';
import { Alert, Button, Stack, TextField } from '@mui/material';
import unsplash from '../api/unsplash';
import GlobalSnackbar from './Snackbar';
import PasswordPageShell from './PasswordPageShell';
import { LockResetOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const ResetPasswordGeneric = ({ apiEndpoint, titolo, loginUrl }) => {
    const [openSnack, setOpenSnack] = useState(false);
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio:
            'Ti abbiamo inviato una mail con il link per resettare la password',
    });
    const [completed, setCompleted] = useState(false);

    const usernameRef = useRef();

    const handleCloseSnack = () => setOpenSnack(false);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        try {
            const response = await unsplash.post(apiEndpoint, {
                username: usernameRef.current.value,
            });

            if (response.data.status && !response.data.onError) {
                setCompleted(true);
                setOpenSnack(true);
                setSnack({
                    severity: 'success',
                    messaggio:
                        'Ti abbiamo inviato una mail con il link per resettare la password',
                });
            } else {
                const msg = response.data.errors?.[0] || 'Errore imprevisto';
                setSnack({ severity: 'error', messaggio: msg });
                setOpenSnack(true);
            }
        } catch (e) {
            setSnack({
                severity: 'error',
                messaggio: 'ERRORE: errore durante il reset password',
            });
            setOpenSnack(true);
        }
    };

    return (
        <PasswordPageShell
            icon={<LockResetOutlined />}
            title="Recupera la password"
            subtitle="Ricevi via email un link sicuro per sceglierne una nuova"
        >
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />

            {!completed ? (
                <Stack
                    component="form"
                    spacing={2}
                    onSubmit={handleResetPassword}
                >
                    <TextField
                        inputRef={usernameRef}
                        id="username"
                        label={titolo}
                        placeholder={`Inserisci ${titolo.toLowerCase()}`}
                        autoComplete="username"
                        autoFocus
                        required
                        fullWidth
                    />
                    <Button
                        type="submit"
                        fullWidth
                        size="large"
                        variant="contained"
                        sx={{
                            py: 1.4,
                            bgcolor: '#11526f',
                            fontWeight: 700,
                        }}
                    >
                        Invia link di reset
                    </Button>
                </Stack>
            ) : (
                <Alert severity="success">
                    Controlla la tua email: ti abbiamo inviato il link per
                    reimpostare la password.
                </Alert>
            )}
            <Button
                component={Link}
                to={loginUrl}
                fullWidth
                sx={{ mt: 2, color: '#11526f', fontWeight: 700 }}
            >
                Torna alla login
            </Button>
        </PasswordPageShell>
    );
};

export default ResetPasswordGeneric;
